import { createContext, useContext } from "react";

// Pages register their header metadata (title/subtitle/actions) into the
// persistent ConsoleShell via this context, so the shell chrome (sidebar +
// header) stays mounted across route changes and only the content swaps.
export interface ConsoleHeaderMeta {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export interface ConsoleLayoutContextValue {
  setMeta: (meta: ConsoleHeaderMeta) => void;
}

export const ConsoleLayoutContext = createContext<ConsoleLayoutContextValue | null>(null);

export function useConsoleLayoutContext() {
  return useContext(ConsoleLayoutContext);
}
